import { appConfig } from './app.config';

export const defaultConfig = {
  ...appConfig,
  eventClasses: [
    'startApp', 'sessionObtained', 'sessionEstablished', 'formActivity', 'sessionToBeClosed', 'sessionEnded', 'noSessionNext', 'notAuthorized',
    'serverProcessStarted', 'serverProcessEnded', 'configLoaded', 'apiReady', 'notification', 'chat',
    'chatMessage', 'messageRead', 'profileObtained', 'sessionSignKeyReceived', 'sessionEncryptKeyReceived'],
  settings: {
    locale: 'en-US',
    isSidebarOpen: false,
    isSupportChatOpen: false,
    isMobileView: false,
    isMobileMenuOpen: false,
    isMenuCollapsed: false,
    menuLayoutType: 'left', // left, top, nomenu
    routerAnimation: 'slideFadeinUp', // none, slideFadeinUp, slideFadeinRight, Fadein, zoomFadein
    menuColor: 'gray', // white, dark, gray
    theme: 'default', // default, dark
    authPagesColor: 'white', // white, gray, image
    primaryColor: '#e78634',
    leftMenuWidth: 284,
    isMenuUnfixed: false,
    isMenuShadow: false,
    isTopbarFixed: false,
    isGrayTopbar: false,
    isContentMaxWidth: false,
    isAppMaxWidth: false,
    isGrayBackground: false,
    isCardShadow: true,
    isSquaredBorders: false,
    isBorderless: false,
  },
};
